module.exports = __webpack_public_path__ + "img/igicon.754b2b85.png";